import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  DataGrid,
  GridToolbarQuickFilter,
  GridLinkOperator,
  gridClasses,
  GridToolbarColumnsButton,
  GridToolbarExportContainer,
} from "@mui/x-data-grid";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import FormControl from "@mui/material/FormControl";
import GridItemLogin from "components/Grid/GridItemLogin.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeadertab.js";
import CloseIcon from "@mui/icons-material/Close";
import Button from "@mui/material/Button";
import Themtrungtamdangkiem from "components/Danhmuc/Trungtamdangkiem/Themtrungtamdangkiem.js";
import Capnhattrungtamdangkiem from "components/Danhmuc/Trungtamdangkiem/Capnhattrungtamdangkiem.js";
import Trungtamdangkiemexcel from "components/Xuatexcel/Danhmuc/Trungtamdangkiemexcel.js";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";
import Config from "conFig.js";
import styles from "assets/jss/material-dashboard-react/components/tableviewStyle.js";
const useStyles = makeStyles(styles);
const datagridSx = {
  [`& .${gridClasses.cell}`]: {
    py: 1,
  },
  [`& .center`]: {
    justifyContent: "center !important",
  },
  borderRadius: 2,
  "& .MuiDataGrid-main": { borderRadius: 2 },
  "& .MuiDataGrid-virtualScrollerRenderZone": {
    "& .MuiDataGrid-row": {
      "&:nth-of-type(2n)": { backgroundColor: "rgba(235, 235, 235, .7)" },
    },
  },
  "& .MuiDataGrid-columnHeaders": {
    backgroundColor: "rgba(0,0,255,0.6)",
    color: "rgb(255 255 255)",
    fontSize: 16,
  },
  "& .MuiInputBase-root": {
    height: "25px",
  },
};
const dkcolumn = [
  {
    field: "stt",
    headerName: "STT",
    width: 90,
    headerAlign: "center",
  },
  {
    field: "ten",
    headerName: "Tên trung tâm",
    width: 300,
    headerAlign: "center",
  },
  {
    field: "diachi",
    headerName: "Địa chỉ",
    width: 250,
    headerAlign: "center",
  },
  {
    field: "phuongxa",
    headerName: "Phường/xã",
    width: 150,
    headerAlign: "center",
  },
  {
    field: "sodienthoai",
    headerName: "Số điện thoại",
    width: 150,
    headerAlign: "center",
  },
  {
    field: "tongsodkv",
    headerName: "Tổng số ĐK viên",
    width: 150,
    headerAlign: "center",
  },
  {
    field: "dkvbaccao",
    headerName: "Số ĐK viên bậc cao",
    width: 170,
    headerAlign: "center",
  },
  {
    field: "tongsodaychuyen",
    headerName: "Tổng số dây chuyền",
    width: 180,
    headerAlign: "center",
  },
  {
    field: "sldaychuyenkiemdinh",
    headerName: "Số dây chuyền kiểm định",
    width: 190,
    headerAlign: "center",
  },
  {
    field: "loaidaychuyenkiemdinh",
    headerName: "Loại dây chuyền kiểm định",
    width: 200,
    headerAlign: "center",
  },
  {
    field: "sodaychuyenhoatdong",
    headerName: "Số dây chuyền hoạt động",
    width: 190,
    headerAlign: "center",
  },
  {
    field: "sonhanviennghiepvu",
    headerName: "Số nhân viên nghiệp vụ",
    width: 180,
    headerAlign: "center",
  },
  {
    field: "thutruongdonvi",
    headerName: "Thủ trưởng",
    width: 150,
    headerAlign: "center",
  },
  {
    field: "coquanquanly",
    headerName: "Đơn vị quản lý",
    width: 150,
    headerAlign: "center",
  },
];
export default function Trungtamdangkiem() {
  const classes = useStyles();
  const [ttdangkiem, setTtdangkiem] = React.useState([]);
  const [trungtamid, setTrungtamid] = React.useState(0);
  const [pageSize, setPageSize] = React.useState(50);
  const [openthem, setOpenthem] = React.useState(false);
  const [opencapnhat, setOpencapnhat] = React.useState(false);
  const [alert, setAlert] = React.useState(false);
  const [disableBT, setDisableBT] = React.useState(true);
  const handleClose = () => {
    setOpenthem(false);
    getttdangkiem();
  };
  const handleClosecapnhat = () => {
    setOpencapnhat(false);
    getttdangkiem();
  };
  const openthempt = () => {
    setOpenthem(true);
  };
  const token = localStorage.getItem("token");
  var username = localStorage.getItem("username");
  var obj = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };
  const quickSearchToolbar = () => {
    return (
      <Box
        sx={{
          p: 0.5,
          pb: 0,
        }}
      >
        <GridToolbarQuickFilter
          quickFilterParser={(searchInput: string) =>
            searchInput
              .split(",")
              .map((value) => value.trim())
              .filter((value) => value !== "")
          }
          placeholder="Tìm kiếm"
        />
        <GridToolbarColumnsButton />
        <GridToolbarExportContainer>
          <Trungtamdangkiemexcel />
        </GridToolbarExportContainer>
      </Box>
    );
  };
  const getttdangkiem = () => {
    var url =
      Config.backend + "/api/Donvi/gettrungtamdangkiemall?username=" + username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        setTtdangkiem(data);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const xoatrungtam = () => {
    var url = Config.backend + "/api/CosoGTVT/xoatrungtamdangkiem";
    fetch(url, {
      method: "DELETE",
      headers: {
        Accept: "application/json, text/plain",
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify({
        id: trungtamid,
        username: username,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data === 1) {
          showNotification();
          getttdangkiem();
          setDisableBT(true);
        }
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const showNotification = () => {
    setAlert(true);
    setTimeout(function () {
      setAlert(false);
    }, 2000);
  };
  React.useEffect(() => {
    getttdangkiem();
  }, []);
  return (
    <GridContainer>
      <GridItem xs={12} sm={10} md={12} style={{ marginTop: 5 }}>
        <FormControl style={{ width: "12%" }}>
          <Button
            color="primary"
            variant="contained"
            style={{ height: 27 }}
            onClick={openthempt}
          >
            Thêm mới
          </Button>
        </FormControl>
        <FormControl style={{ width: "8%", marginLeft: 10 }}>
          <Button
            color="error"
            variant="contained"
            style={{ height: 27 }}
            disabled={disableBT}
            onClick={xoatrungtam}
          >
            Xóa
          </Button>
        </FormControl>
      </GridItem>
      <GridItem xs={12} sm={10} md={12} style={{ marginTop: 10 }}>
        <div style={{ height: 500, width: "100%" }}>
          <DataGrid
            getRowId={(row) => row.id}
            rows={ttdangkiem}
            columns={dkcolumn}
            checkboxSelection={false}
            getRowHeight={() => "auto"}
            headerHeight={35}
            onRowClick={(params) => {
              setDisableBT(false);
              setTrungtamid(params.row.id);
            }}
            onCellDoubleClick={(params, event) => {
              if (!event.ctrlKey) {
                setOpencapnhat(true);
              }
            }}
            sx={datagridSx}
            pageSize={pageSize}
            onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
            rowsPerPageOptions={[20, 50, 100]}
            pagination
            initialState={{
              filter: {
                filterModel: {
                  items: [],
                  quickFilterLogicOperator: GridLinkOperator.Or,
                },
              },
            }}
            components={{ Toolbar: quickSearchToolbar }}
          />
        </div>
      </GridItem>
      <GridItem xs={12} sm={10} md={12}>
        <Modal
          open={openthem}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <div>
            <GridContainer>
              <GridItemLogin xs={12} sm={12} md={3}></GridItemLogin>
              <GridItemLogin xs={12} sm={12} md={6}>
                <Card>
                  <CardHeader color="primary" style={{ height: 10 }}>
                    <GridContainer>
                      <GridItem xs={12} sm={12} md={10}>
                        <FormControl
                          style={{ width: "100%", marginTop: "10px" }}
                        >
                          <h6
                            className={classes.cardTitleWhite}
                            style={{ marginTop: "-5px" }}
                          >
                            Thêm trung tâm đăng kiểm
                          </h6>
                        </FormControl>
                      </GridItem>
                      <GridItem xs={12} sm={12} md={1}></GridItem>
                      <GridItem xs={12} sm={12} md={1}>
                        <FormControl
                          style={{ width: "100%", marginTop: "1px" }}
                        >
                          <CloseIcon onClick={handleClose} />
                        </FormControl>
                      </GridItem>
                    </GridContainer>
                  </CardHeader>
                  <Themtrungtamdangkiem />
                </Card>
              </GridItemLogin>
              <GridItemLogin xs={12} sm={12} md={3}></GridItemLogin>
            </GridContainer>
          </div>
        </Modal>
      </GridItem>
      <GridItem xs={12} sm={10} md={12}>
        <Modal
          open={opencapnhat}
          onClose={handleClosecapnhat}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <div>
            <GridContainer>
              <GridItemLogin xs={12} sm={12} md={3}></GridItemLogin>
              <GridItemLogin xs={12} sm={12} md={6}>
                <Card>
                  <CardHeader color="primary" style={{ height: 10 }}>
                    <GridContainer>
                      <GridItem xs={12} sm={12} md={10}>
                        <FormControl
                          style={{ width: "100%", marginTop: "10px" }}
                        >
                          <h6
                            className={classes.cardTitleWhite}
                            style={{ marginTop: "-5px" }}
                          >
                            Cập nhật trung tâm đăng kiểm
                          </h6>
                        </FormControl>
                      </GridItem>
                      <GridItem xs={12} sm={12} md={1}></GridItem>
                      <GridItem xs={12} sm={12} md={1}>
                        <FormControl
                          style={{ width: "100%", marginTop: "1px" }}
                        >
                          <CloseIcon onClick={handleClosecapnhat} />
                        </FormControl>
                      </GridItem>
                    </GridContainer>
                  </CardHeader>
                  <Capnhattrungtamdangkiem trungtam_id={trungtamid} />
                </Card>
              </GridItemLogin>
              <GridItemLogin xs={12} sm={12} md={3}></GridItemLogin>
            </GridContainer>
          </div>
        </Modal>
      </GridItem>
      <GridContainer>
        <GridItem xs={12} sm={12} md={10} lg={8}>
          <Snackbar
            place="tc"
            color="info"
            icon={AddAlert}
            message="Xóa thành công"
            open={alert}
            closeNotification={() => setAlert(false)}
            close
          />
        </GridItem>
      </GridContainer>
    </GridContainer>
  );
}
